import { LoginForm } from './LoginForm';
import { useLocalization } from '@ais-ui/locale-management';

interface WhitelabelConfig {
  signInImagePath: string;
  testimonialText?: string;
  testimonialAuthor?: string;
}

interface AuthenticationPageProps {
  whitelabel?: WhitelabelConfig;
}

export function AuthenticationPage({ whitelabel }: AuthenticationPageProps) {
  const { messages } = useLocalization();

  return (
    <>
      <div className="container relative h-screen flex-col items-center justify-center grid lg:max-w-none lg:grid-cols-2 lg:px-0">
        <div className="relative hidden h-full flex-col bg-muted p-10 text-white dark:border-r lg:flex">
          <div className="absolute inset-0 bg-sign-in" />
          <div className="relative z-20 flex items-center text-lg font-medium">
            <img
              src={whitelabel?.signInImagePath ?? ''}
              alt="Home logo"
              className="w-40 object-contain"
            />
          </div>
          <div className="relative z-20 mt-auto">
            <blockquote className="space-y-2 text-primary-foreground">
              <p className="text-lg">
                &ldquo;
                {whitelabel?.testimonialText
                  ? whitelabel.testimonialText
                  : messages.loginTestimonial}
                &rdquo;
              </p>
              <footer className="text-sm">
                {whitelabel?.testimonialAuthor
                  ? whitelabel.testimonialAuthor
                  : messages.loginTestimonialAuthor}
              </footer>
            </blockquote>
          </div>
        </div>
        <div className="lg:p-8">
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 md:w-[350px]">
            <div className="flex flex-col space-y-2 text-center">
              <h1 className="text-2xl font-semibold tracking-tight">
                {messages.loginSignIn}
              </h1>
              <p className="text-sm text-muted-foreground">
                {messages.loginEnterUsernamePassword}
              </p>
            </div>
            <LoginForm />
          </div>
        </div>
      </div>
    </>
  );
}
